export const SIGNATURE_ATTESTATION = `Please read the statement and provide your signature below

By signing below, I certify that all the information I have provided is accurate to the best of my knowledge, and that I understand, accept the risks and fully agree to all of the terms.`;
